import React from "react";
import { css } from "@emotion/react";
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
import HashLoader from "react-spinners/ClockLoader";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class AwesomeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      color: "#e77820",
    };
  }

  render() {
    return (
      <>
        {this.props.loading ? (
          <div className="sweet-loader-css flex justify-center items-center h-full w-full fixed top-0 ">
            <HashLoader
              color={this.state.color}
              loading={this.props.loading || false}
              css={override}
              size={100}
            />
          </div>
        ) : (
          <div className="sweet-loader-css">
            <ClimbingBoxLoader
              color={this.state.color}
              loading={this.props.loading || false}
              css={override}
              size={30}
            />
          </div>
        )}
      </>
    );
  }
}
export default AwesomeComponent;
